import React, { useState } from 'react';
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../../../redux/actions/wizardActions";

const OktaImportConfiguration = () => {
  const [checkboxes, setCheckboxes] = useState({
    'Okta Apps': { checked: false, value: 'Okta Apps' },
    'Okta Roles': { checked: false, value: 'Okta Roles' },
    'Okta Policies': { checked: false, value: 'Okta Policies' },
    'Okta Users': { checked: false, value: 'Okta Users' },
    'Okta Groups': { checked: false, value: 'Okta Groups' },
  });

  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);

  const handleInputChange = (event, key) => {
    const { value } = event.target;
    setCheckboxes({
      ...checkboxes,
      [key]: { ...checkboxes[key], value: value },
    });

    const updatedData = {
      ...currentData,
      oktaConfig: { ...checkboxes, [key]: { ...checkboxes[key], value: value } }
    };
    dispatch(setCurrentWizardData(updatedData));
  };
  const handleCheckboxChange = (key) => {
    const checked = checkboxes[key].checked;
    setCheckboxes({
      ...checkboxes,
      [key]: { ...checkboxes[key], checked: !checked },
    });
    const updatedData = {
      ...currentData,
      oktaConfig: { ...checkboxes, [key]: { ...checkboxes[key], checked: !checked } }
    };
    dispatch(setCurrentWizardData(updatedData));
  };



  return (
    <div>
      <br/>
      <h3>Select what to import from Okta: </h3>
      {Object.keys(checkboxes).map((key, index) => (
        <div key={index}>
          <label>
            <input
              type="checkbox"
              checked={checkboxes[key].checked}
              onChange={() => handleCheckboxChange(key)}
            />
            {key}
          </label>
          {checkboxes[key].checked && (
            <><Textfield
            type="text"
            value={checkboxes[key].value}
            onChange={(event) => handleInputChange(event, key)}
          />
          This field sets the name of the <b>Object Type</b> in assets where the imported <b>{key}</b> will be shown.</>            
          )}
        </div>
      ))}
    </div>
  );
};

export default OktaImportConfiguration;